var _path, _path2, _rect, _path3, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9989 80.9978C63.0897 80.9978 80.9978 63.0897 80.9978 40.9989C80.9978 18.9081 63.0897 1 40.9989 1C18.9081 1 1 18.9081 1 40.9989C1 63.0897 18.9081 80.9978 40.9989 80.9978Z",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 90L70 70",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23.8799,
    width: 14.3371,
    height: 14.3371,
    rx: 3,
    stroke: "#2884FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6738 29.1883L49.0917 22.7704C50.1189 21.7432 51.7845 21.7432 52.8117 22.7704L59.2296 29.1883C60.2568 30.2155 60.2568 31.8811 59.2296 32.9083L52.8117 39.3262C51.7845 40.3534 50.1189 40.3534 49.0917 39.3262L42.6738 32.9083C41.6466 31.8811 41.6466 30.2155 42.6738 29.1883Z",
    stroke: "#2884FF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 45.6625,
    width: 14.3371,
    height: 14.3371,
    rx: 3,
    stroke: "#2884FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7832,
    y: 45.6625,
    width: 14.3371,
    height: 14.3371,
    rx: 3,
    stroke: "#2884FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultPattern);
export default __webpack_public_path__ + "static/media/no-result-pattern.8c6be076964bff36144d666e877d32a6.svg";
export { ForwardRef as ReactComponent };